export default __webpack_public_path__ + "static/media/straight.bc31e32c.png";